import { Injectable } from "@angular/core";
import { RouterNavigation } from "@ngxs/router-plugin";
import { Action, Selector, State, StateContext } from "@ngxs/store";

export class FilterCandidatePlanningAction {
  static type = "[Planning Filter] ";
  constructor(public candidateId: string) {}
}
export class UndoFilterCandidatePlanningAction {
  static type = "[Planning Filter] Undo";
}

export const initialState = { filter: (p) => p };
export interface PlanningFilterStateModel {
  filter: any;
}
@State<PlanningFilterStateModel>({
  name: "planningFilter",
  defaults: initialState,
})
@Injectable()
export class PlanningFilterState {
  @Selector()
  static filter(state: PlanningFilterStateModel) {
    return state.filter;
  }

  @Action(RouterNavigation)
  navigating(ctx: StateContext<PlanningFilterState>, action: RouterNavigation) {
    if (
      action.routerState.url.indexOf("plan") !== -1 &&
      action.routerState.url.indexOf("candidateprogress") === -1
    ) {
      return ctx.dispatch(new UndoFilterCandidatePlanningAction());
    }
  }

  @Action(FilterCandidatePlanningAction)
  filter(
    ctx: StateContext<PlanningFilterStateModel>,
    action: FilterCandidatePlanningAction
  ) {
    ctx.patchState({
      filter: (p) =>
        p.hasOwnProperty("candidateId")
          ? p.candidateId === action.candidateId
          : p.id === action.candidateId,
    });
  }
  @Action(UndoFilterCandidatePlanningAction)
  showAll(ctx: StateContext<PlanningFilterStateModel>) {
    ctx.patchState({ ...initialState });
  }
}
